var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ height: this.$store.state.availableTableHeight })},[_c('incident-viewer',{attrs:{"incidentId":_vm.incidentId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }